// extracted by mini-css-extract-plugin
module.exports = {"download_btn":"pwaInstall_download_btn__NgJsk","imgStyle":"pwaInstall_imgStyle__jEV6H"};